import { API_ENDPOINT } from './config';

export const urlsMeteo = {
  sensors: `${API_ENDPOINT}/sensors`,
  sensorDetail: (id) => `${API_ENDPOINT}/sensors/${id}`,
  sensorsWithGraphableAttributes: `${API_ENDPOINT}/sensors-with-graphable-attributes`,
  orderedSensorsAttributes: `${API_ENDPOINT}/ordered-sensor-attributes`,
  sensorsAttributes: (sensorId) =>
    `${API_ENDPOINT}/sensors/${sensorId}/sensor-attributes`,
  sensorAttributesDetail: (sensorId, attributeId) =>
    `${API_ENDPOINT}/sensors/${sensorId}/sensor-attributes/${attributeId}`,
  attributeUnits: `${API_ENDPOINT}/attribute-units`,
  attributeUnitDetail: (id) => `${API_ENDPOINT}/attribute-units/${id}`,
  sensorValuesPreview: `${API_ENDPOINT}/sensor-values-preview`,
  sensorValuesStatistics: `${API_ENDPOINT}/sensor-values-statistics`,
};

export const routesMeteo = {
  //Public
  meteoStation: '/meteo-stanica',

  // CMS
  cmsMeteoStation: '/cms/meteo-station',
  cmsMeteoStationEdit: '/cms/meteo-station/edit',
  cmsMeteoStationCreate: '/cms/meteo-station/create',
  cmsMeteoStationSensors: '/cms/meteo-station/sensors',
  cmsMeteoStationSensorsDetail: (sensorId) =>
    `/cms/meteo-station/sensors/${sensorId}`,
  cmsMeteoStationSensorsEdit: (sensorId) =>
    `/cms/meteo-station/sensors/${sensorId}/edit`,
  cmsMeteoStationSensorsAttributes: (sensorId) =>
    `/cms/meteo-station/sensors/${sensorId}/attributes`,
  cmsMeteoStationSensorsAttributesCreate: (sensorId) =>
    `/cms/meteo-station/sensors/${sensorId}/attributes/create`,
  cmsMeteoStationSensorsAttributeEdit: (sensorId, attributeId) =>
    `/cms/meteo-station/sensors/${sensorId}/attributes/${attributeId}/edit`,
  cmsMeteoStationUnits: '/cms/meteo-station/units',
  cmsMeteoStationUnitsDetail: (unitId) => `/cms/meteo-station/units/${unitId}`,
  cmsMeteoStationUnitsCreate: '/cms/meteo-station/units/create',
};
